import { useNavigate } from '@tanstack/react-router';
import type { SavedReportItem } from '../api/types';
import { useSwitchAccountMutation } from '../api/queries';
import { useAccountStore } from '../lib/account-store';
import {
  buildPendingSavedSearchPayload,
  persistPendingSavedSearchPayload,
} from '../lib/saved-searches';

export const useOpenSavedSearch = () => {
  const navigate = useNavigate();
  const account = useAccountStore(state => state.account);
  const switchAccountMutation = useSwitchAccountMutation();

  return async (report: SavedReportItem, fallbackDataset?: string) => {
    if (!account?._id) {
      throw new Error('No se encontró la cuenta activa para abrir la búsqueda guardada.');
    }

    const payload = buildPendingSavedSearchPayload(report, fallbackDataset);
    if (!payload) {
      throw new Error('La búsqueda guardada no tiene la información necesaria para abrirse.');
    }

    persistPendingSavedSearchPayload(payload);

    if (account.dataset !== payload.dataset || account.table !== payload.table) {
      await switchAccountMutation.mutateAsync({
        account: account._id,
        dataset: payload.dataset,
        table: payload.table,
      });
    }

    await navigate({
      to: '/data/table/$tableId',
      params: { tableId: payload.table },
    });
  };
};
